import { render } from "./FilterCategoryItem.vue?vue&type=template&id=0338aece&scoped=true"
import script from "./FilterCategoryItem.vue?vue&type=script&lang=js"
export * from "./FilterCategoryItem.vue?vue&type=script&lang=js"

import "./FilterCategoryItem.vue?vue&type=style&index=0&id=0338aece&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0338aece"]])

export default __exports__